export default "__VITE_ASSET__D18GTHrz__"